import React from "react";
import Sidebar from "app/layout/Sidebar";
import { SubmissionError } from "redux-form";
import {
  compose,
  renderComponent,
  branch,
  withState,
  withHandlers,
  withProps,
  renderNothing
} from "recompose";
import { Spinner } from "@blueprintjs/core";
import ProposalView from "./ProposalView";
import ProposalUpdateForm from "./ProposalUpdateForm";
import { connectTopicActions } from "app/topics/hocs";
import { withProposals } from "./hocs";
import { GET, ON_SUBMIT } from "./constants";

const GetError = props => {
  const { proposals, proposalId, onClose } = props;
  return (
    <Sidebar title="Error" onClose={onClose}>
      {proposals.actions[GET][proposalId].data.message}
    </Sidebar>
  );
};

const withCases = compose(
  branch(
    ({ proposals, proposalId }) => !proposals.actions[GET][proposalId],
    renderNothing
  ),
  withProps(props => {
    const { proposals, proposalId } = props;
    return {
      proposals,
      proposalId,
      [proposals.actions[GET][proposalId].type]: true
    };
  }),
  branch(props => props[GET.PENDING], renderComponent(Spinner)),
  branch(props => props[GET.ERROR], renderComponent(GetError)),
  renderNothing
);

const onDeleteClick = ({
  topicId,
  proposalId,
  onClose,
  removeProposal,
  deleteDraft,
  deleteProposal,
  proposal: {
    ui: { isDraft }
  },
  user
}) => () => {
  onClose();
  removeProposal({ topicId, proposalId });
  if (isDraft) {
    deleteDraft({ topicId, proposalId });
  } else {
    deleteProposal({ topicId, proposalId });
  }
};
const onPublishClick = ({
  proposalId,
  onSubmitDraft,
  deleteDraft,
  history
}) => () => {
  return onSubmitDraft({ proposalId })
    .then(props => {
      const {
        data: { _id, topicId }
      } = props;
      const urlSearch = window.location.search;
      return deleteDraft({ proposalId }).then(() => {
        history.replace(`/topics/${topicId}/p/${_id}${urlSearch}`);
      });
    })
    .catch(error => {
      if (error && error.type === ON_SUBMIT.ERROR) {
        throw new SubmissionError({ _error: error });
      }
      throw error;
    });
};

const inNormalMode = compose(
  withHandlers({
    onEditClick: props => () => props.setMode("edit"),
    onDeleteClick,
    onPublishClick,
    submitCallback: props => () => props.setMode({ mode: "normal" })
  }),
  withProps(props => {
    const { proposalId, proposal: { title } = {} } = props;
    return {
      title: title || proposalId
    };
  }),
  Sidebar => props => {
    const { title, onClose, ...rest } = props;
    return (
      <Sidebar title={title} onClose={onClose}>
        <ProposalView {...rest} />
      </Sidebar>
    );
  }
);

const onCancelClick = props => () => props.setMode("normal");

const inEditMode = compose(
  withHandlers({
    onCancelClick,
    onClose: onCancelClick,
    onSubmitSuccess: onCancelClick
  }),
  withProps(props => {
    const { proposalId, proposal: { title } = {} } = props;
    return {
      title: `Edit ${title || proposalId}`
    };
  }),
  Sidebar => props => {
    const { title, onClose, ...rest } = props;
    return (
      <Sidebar title={title} onClose={onClose}>
        <ProposalUpdateForm {...rest} />
      </Sidebar>
    );
  }
);

const enhance = compose(
  withProposals,
  branch(({ proposal }) => !proposal, withCases),
  withState("mode", "setMode", "normal"),
  connectTopicActions,
  branch(({ mode }) => mode === "edit", inEditMode),
  branch(({ mode }) => mode === "normal", inNormalMode)
);

export default enhance(Sidebar);



// WEBPACK FOOTER //
// ./src/app/proposals/ProposalSidebar.js